import { Companion_getInstance3nwjuy29c0uei as Companion_getInstance } from '../type/SecretId.mjs';
import {
  notNull3hndh47e9bowl as notNull,
  Builder320ghmibyd2no as Builder,
  Builder3t31vflw4km89 as Builder_0,
  CompiledVariablecaz6ndkw7us2 as CompiledVariable,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { Companion_getInstance2lus0w6jtm2rt as Companion_getInstance_0 } from '../type/GraphQLString.mjs';
import { Companion_getInstance1w7n91qce015n as Companion_getInstance_1 } from '../type/DateTimeISO.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Companion_getInstance3i9l0rhq56ftk as Companion_getInstance_2 } from '../type/SecretToken.mjs';
import { Companion_getInstance1m1mmkl5t8eg3 as Companion_getInstance_3 } from '../type/Mutation.mjs';
import { listOfvhqybd2zx248 as listOf_0 } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CreateSecretMutationSelectionsClass;
function CreateSecretMutationSelections() {
  if (CreateSecretMutationSelectionsClass === VOID) {
    class $ {
      constructor() {
        CreateSecretMutationSelections_instance = this;
        this.x6d_1 = listOf([(new (Builder())('secretId', notNull(Companion_getInstance().p6o_1))).i37(), (new (Builder())('description', notNull(Companion_getInstance_0().x6n_1))).i37(), (new (Builder())('createdTimestamp', notNull(Companion_getInstance_1().t6n_1))).i37(), (new (Builder())('lastUsedTimestamp', Companion_getInstance_1().t6n_1)).i37(), (new (Builder())('secretToken', notNull(Companion_getInstance_0().x6n_1))).i37()]);
        this.y6d_1 = listOf_0((new (Builder())('createSecret', Companion_getInstance_2().u6o_1)).r43(listOf_0((new (Builder_0())(Companion_getInstance_3().n6d_1)).c44(new (CompiledVariable())('input')).i37())).s43(this.x6d_1).i37());
      }
    }
    initMetadataForObject($, 'CreateSecretMutationSelections');
    CreateSecretMutationSelectionsClass = $;
  }
  return CreateSecretMutationSelectionsClass;
}
var CreateSecretMutationSelections_instance;
function CreateSecretMutationSelections_getInstance() {
  if (CreateSecretMutationSelections_instance === VOID)
    new (CreateSecretMutationSelections())();
  return CreateSecretMutationSelections_instance;
}
//region block: exports
export {
  CreateSecretMutationSelections_getInstance as CreateSecretMutationSelections_getInstance3o0j0kz01hzpn,
};
//endregion

//# sourceMappingURL=CreateSecretMutationSelections.mjs.map
